<template>
  <div class="chaxunResult">
    <div class="head">查询结果</div>
  
    <div class="noinfo">
      <div class="inNoinfo">
        <img src="../assets/images/noInfo.png" alt="" />
        <div class="word">未查询到结果</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
};
</script>

<style lang="scss" scoped>
.chaxunResult {
  background-color: #f4f4f4;
  min-height: 100vh;
  padding: 9.125rem 2rem 0 2rem;
  background-image: url("../assets/images/mingxiBg.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.head {
  color: #ffffff;
  font-size: 2.625rem;
  line-height: 3.875rem;
  font-weight: bold;
}
.list {
  margin-top: 2.375rem;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(205, 205, 205, 0.25);
  border-radius: 8px;
  .listHead {
    padding: 2rem 2.375rem 1.5rem 2.375rem;
    font-weight: 400;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    justify-content: space-between;
    .everyTitle {
      color: #19212a;
      font-size: 1.75rem;
    }
  }
  .inList {
    padding: 1.5rem 1.125rem 2rem 1.125rem;
    display: flex;
    justify-content: space-between;
    .everyData {
      color: #555555;
      font-size: 1.75rem;
      width: 9.5rem;
      text-align: center;
      white-space: nowrap;
    }
  }
  .active {
    background: #fff8e8;
    padding: 1rem 1.125rem;
    white-space: nowrap;
  }
}
.noinfo {
  height: 37.5rem;
  display: flex;
  justify-content: center;
  padding-top: 9.125rem;
  background: #ffffff;
  border-radius: 6px;
  margin-top: 11.25rem;
  .inNoinfo {
    img {
      width: 18.75rem;
      height: 15.375rem;
    }
    .word {
      text-align: center;
      color: #555555;
      font-size: 2rem;
      margin-top: 3.25rem;
      font-weight: bold;
    }
  }
}
</style>